// cookie consent
(function(){
	var Cookie = (function(){
		return {
          getItem: function (sKey) {
            if (!sKey || !this.hasOwnProperty(sKey)) { return null; }
            return unescape(document.cookie.replace(new RegExp("(?:^|.*;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"), "$1"));
          },
          key: function (nKeyId) {
            return unescape(document.cookie.replace(/\s*\=(?:.(?!;))*$/, "").split(/\s*\=(?:[^;](?!;))*[^;]?;\s*/)[nKeyId]);
          },
          setItem: function (sKey, sValue, expDays) {
            if(!sKey) { return; }
            if(!expDays) expDays = 365;
            var d = new Date();
    		d.setTime(d.getTime() + (expDays*24*60*60*1000));
            document.cookie = escape(sKey) + "=" + escape(sValue) + "; expires="+d.toUTCString()+"; path=/";
            this.length = document.cookie.match(/\=/g).length;
          },
          length: 0,
          removeItem: function (sKey) {
            if (!sKey || !this.hasOwnProperty(sKey)) { return; }
            document.cookie = escape(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
            this.length--;
          },
          hasOwnProperty: function (sKey) {
            return (new RegExp("(?:^|;\\s*)" + escape(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
          }
    	}
	}());
  
    
    $(function(){
      	var cookies_enabled = false;
      
    	try {
          Cookie.setItem('cookies_enabled','true');
          if(Cookie.getItem('cookies_enabled') === 'true') {
            Cookie.removeItem('cookies_enabled');
            cookies_enabled = true;
          }
      	} catch(e){}
          
      
		var cookieSettings = {
          cookieName:"cookie-consent",
          cookieText:"We use cookies on this site,",
          cookiePolicy:"read more here",
          cookiePage:"privacy-policy",
          cookieButton:"I accept"
        };

        function showCookieBar(o){
          // check if we can use cookies and have approval
          if(Cookie.getItem(o.cookieName) !== 'on') {
            var cookiebar = document.createElement('div'),
                consentButton, html = '';

            cookiebar.id = o.cookieName;
            cookiebar.className = 'display';
            html+='<center>';
            html+=o.cookieText;
            html+='&nbsp;<a href="/pages/' + o.cookiePage + '">' + o.cookiePolicy + '</a>.';
            html+='<button id="cookie-consent-button" class="consent">' +  o.cookieButton + '</button>';
            html+='</center>';
            cookiebar.innerHTML = html;

            document.body.insertBefore(cookiebar,document.body.firstChild);

            var consentButton = document.getElementById('cookie-consent-button');
            
            if(consentButton){
              consentButton.onclick = function(){
                var consent = document.getElementById(o.cookieName);
              	if(consent) consent.className = '';
              	Cookie.setItem(o.cookieName,'on',14); // for two weeks
              }
            }
          }
        }
        // only show if we are able to set/get cookies
        if(cookies_enabled) showCookieBar(cookieSettings);
    });
    
}).call(this);